<script lang="ts">
  import LayoutGrid, { Cell } from '@smui/layout-grid';
  import { getAppConfig } from '../../../../common/config/app-config';
  import { CONSTANTS } from '../../../../common/config/constants';
  import {
    getJoodDayCredits,
    selectCorrectSmartPrice,
    selectCorrectSmartPromoBoolean,
  } from '../../../../common/joodUtils';
  import { getJoodExpiredMembershipType, getJoodMembershipType } from '../../../../common/util';
  import Icon from '../../../common/components/Icon.svelte';
  import JoodRemainingQty from '../../../common/components/productTile/components/JoodRemainingQty.svelte';
  import ProductTilePriceNew from '../../../common/components/productTile/components/ProductTilePriceNew.svelte';
  import ProductTilePriceWallet from '../../../common/components/productTile/components/ProductTilePriceWallet.svelte';
  import ProductTileWalletBenefits from '../../../common/components/productTile/components/productTileWalletBenefits.svelte';
  import Text from '../../../common/components/Text.svelte';
  import PictureTag from '../../../common/lazy-components/PictureTag.svelte';
  import JoodDayBannerNew from '../../../product-listing-search/components/JoodDayBannerNew.svelte';
  import JoodDayBannerWallet from '../../../product-listing-search/components/JoodDayBannerWallet.svelte';
  import JoodDayBannerWalletBenefits from '../../../product-listing-search/components/JoodDayBannerWalletBenefits.svelte';
  import { convertProductDataToUnbxdProductData } from '../../services/pdp-data-services';
  import AtcBrandName from './AtcBrandName.svelte';
  import AtcGifts from './AtcGifts.svelte';
  import AtcPrice from './AtcPrice.svelte';

  export let cartData;
  export let isMegasaleProduct = [];
  const { primeEnabled, benefitType = 'DISCOUNT', pageId } = getAppConfig();
  const priceVariant = pageId === 'productDetails' ? 'pdp-popup' : 'qac';
  const { NOPRIME, VIPPRIME, BASICPRIME, SMARTPRIME } = CONSTANTS;
  const priceComponent = benefitType === 'WALLET' ? ProductTilePriceWallet : ProductTilePriceNew;
  const bannerComponent = benefitType === 'WALLET' ? JoodDayBannerWallet : JoodDayBannerNew;

  const productVipPrimeData = cartData?.entry.product?.productVipPrimeData || null;
  const productBasicPrimeData = cartData?.entry.product?.productBasicPrimeData || null;
  const productSmartPrimeData = cartData?.entry.product?.productSmartPrimeData || null;

  const userLevel = getJoodMembershipType();

  const expiredJoodMembershipType = getJoodExpiredMembershipType();
  const userPrimeLevel = expiredJoodMembershipType ? expiredJoodMembershipType : userLevel;
  const productWithAcDiscount = {
    ...cartData?.entry?.product,
    membershipPrice: cartData?.entry?.totalPrice?.value,
    isMemberShipDiscount: cartData?.entry?.membershipDiscount?.value,
    acPriceDiscount: cartData?.entry?.appliedAcPriceDiscount?.formattedValue
      ? cartData?.entry?.appliedAcPriceDiscount?.formattedValue / cartData?.entry?.quantity
      : null,
  };
  const convertProductDataToUnbxd = convertProductDataToUnbxdProductData(productWithAcDiscount);
  const isTacticalBasicPromo = convertProductDataToUnbxd?.tacticalBasicPromo;
  const isTacticalVipPromo = convertProductDataToUnbxd?.tacticalVipPromo;
  const isTacticalSmartPromo = selectCorrectSmartPromoBoolean(
    convertProductDataToUnbxd?.tacticalSmartFirstPromo,
    convertProductDataToUnbxd?.tacticalSmartRepeatingPromo
  );
  const tacticalBasicPrimePrice = convertProductDataToUnbxd?.tacticalBasicPrimePrice;
  const tacticalVipPrimePrice = convertProductDataToUnbxd?.tacticalVipPrimePrice;
  const tacticalSmartPrimePrice = selectCorrectSmartPrice(
    convertProductDataToUnbxd?.tacticalSmartFirstPrimePrice,
    convertProductDataToUnbxd?.tacticalSmartRepeatingPrimePrice
  );
  const smartPrimePrice = selectCorrectSmartPrice(
    convertProductDataToUnbxd?.smartFirstPrimePrice,
    convertProductDataToUnbxd?.smartRepeatingPrimePrice
  );
  const hasJoodPrices =
    (primeEnabled &&
      ((productVipPrimeData?.primePrice?.value > 0 && userPrimeLevel === VIPPRIME) ||
        (productBasicPrimeData?.primePrice?.value > 0 && userPrimeLevel === BASICPRIME) ||
        (smartPrimePrice > 0 && userPrimeLevel === SMARTPRIME))) ||
    false;
  const joodPromoemainingQuantity = convertProductDataToUnbxd?.joodDayRemainingQuantity || 0;

  const remainingQuantityFlag =
    (userPrimeLevel === 'BASICPRIME' && isTacticalBasicPromo) ||
    ((userPrimeLevel === 'NOPRIME' || userPrimeLevel === 'VIPPRIME') && isTacticalVipPromo)
      ? true
      : false;
  const visibleNonMemberPrice =
    userPrimeLevel === 'NOPRIME' ||
    expiredJoodMembershipType ||
    (userPrimeLevel === 'VIPPRIME' && !productVipPrimeData) ||
    (userPrimeLevel === 'BASICPRIME' && !productBasicPrimeData) ||
    (userPrimeLevel === 'SMARTPRIME' && !productSmartPrimeData);
</script>

<section class="add-to-cart-header-section">
  <LayoutGrid>
    <Cell class="add-to-cart-item c_add-to-cart-popup-header" spanDevices={{ phone: 4, tablet: 8, desktop: 12 }}>
      <Icon glyph="check" desktopSize={30} />
      <div class="title">
        <Text key="extra.addtocart.greatchoice" />
        {#if cartData?.bundleQtyAdded > 0}
          <Text key="extra.addtocart.bundle.added" />
        {/if}
      </div>
    </Cell>
    <Cell class="add-to-cart-item c_add-to-cart-popup-item" spanDevices={{ phone: 4, tablet: 8, desktop: 12 }}>
      <div class="c_add-to-cart-popup-item-inner">
        {#if !cartData?.bundleQtyAdded}
          <div class="thumb c_add-to-cart-popup-item-img">
            <a href={cartData?.entry?.product?.url}>
              <PictureTag
                image={cartData?.entry?.product?.amplienceProductBaseUrl}
                alt="Product-image"
                width="100%"
                height="100%"
              />
            </a>
          </div>
        {/if}
        <div class="details c_add-to-cart-popup-item-details">
          {#if cartData?.bundleQtyAdded > 0}
            <div class="c_add-to-cart-popup-bundle">
              {#if cartData?.entries}
                {#each cartData.entries as modific}
                  <div class="c_add-to-cart-popup-bundle-item col-md-3 col-xs-3">
                    <div class="thumb c_add-to-cart-popup-bundle-img">
                      <a href={modific?.product?.url}>
                        <PictureTag
                          image={modific?.product?.amplienceProductBaseUrl}
                          alt="Product-image"
                          width="100%"
                          height="100%"
                        />
                      </a>
                    </div>
                    <span>{modific.product.name}</span>
                  </div>
                {/each}
              {/if}
            </div>
            <div class="c_vas-details-divider row-flex"></div>
          {:else}
            <AtcBrandName {cartData} />
            {#if visibleNonMemberPrice}
              <div class="c_add-to-cart-popup-item-price">
                <AtcPrice entry={cartData?.entry} />
              </div>
            {/if}

            <!-- {#if expiredJoodMembershipType === 'VIPPRIME' || expiredJoodMembershipType === 'BASICPRIME'}
              <JoodSavingsNew
                priceType="NOPRIME"
                displayPrice={expiredJoodMembershipType === 'BASICPRIME'
                  ? convertProductDataToUnbxd?.productBasicPrimeData?.primePrice?.value
                  : expiredJoodMembershipType === 'VIPPRIME'
                    ? convertProductDataToUnbxd?.productVipPrimeData?.vipPrimePrice?.value
                    : expiredJoodMembershipType === 'SMARTPRIME'
                      ? smartPrimePrice
                      : 0}
              />
            {/if} -->
            {#if userPrimeLevel !== 'NOPRIME' && (expiredJoodMembershipType || !visibleNonMemberPrice)}
              {#if hasJoodPrices}
                <div
                  class="c_joodcart-wrapper c_joodprimecart c_joodcart jood-cart-popup js-jood-cart-popup jood-addtocart-popup"
                >
                  {#if primeEnabled}
                    {#if userPrimeLevel === VIPPRIME || expiredJoodMembershipType === VIPPRIME}
                      {#if !isTacticalVipPromo && convertProductDataToUnbxd?.vipPrimePrice}
                        <svelte:component
                          this={priceComponent}
                          {isMegasaleProduct}
                          variant={priceVariant}
                          priceType={VIPPRIME}
                          algoliaProductHit={convertProductDataToUnbxd}
                          backgoundOverride={VIPPRIME}
                        />
                      {:else if tacticalVipPrimePrice && tacticalVipPrimePrice > 0}
                        {#if benefitType === 'WALLET'}
                          <svelte:component
                            this={priceComponent}
                            {isMegasaleProduct}
                            variant={priceVariant}
                            priceType={VIPPRIME}
                            algoliaProductHit={convertProductDataToUnbxd}
                            backgoundOverride={VIPPRIME}
                            showWalletCredits={false}
                          />
                        {/if}
                        <svelte:component
                          this={bannerComponent}
                          variant={priceVariant}
                          bannerType={VIPPRIME}
                          algoliaProductHit={convertProductDataToUnbxd}
                        />
                      {/if}
                    {:else if userPrimeLevel === BASICPRIME || expiredJoodMembershipType === BASICPRIME}
                      {#if !isTacticalBasicPromo && convertProductDataToUnbxd?.basicPrimePrice > 0}
                        <svelte:component
                          this={priceComponent}
                          {isMegasaleProduct}
                          variant={priceVariant}
                          priceType={BASICPRIME}
                          algoliaProductHit={convertProductDataToUnbxd}
                          backgoundOverride={BASICPRIME}
                        />
                      {:else if tacticalBasicPrimePrice && tacticalBasicPrimePrice > 0}
                        {#if benefitType === 'WALLET'}
                          <svelte:component
                            this={priceComponent}
                            {isMegasaleProduct}
                            variant={priceVariant}
                            priceType={BASICPRIME}
                            algoliaProductHit={convertProductDataToUnbxd}
                            backgoundOverride={BASICPRIME}
                            showWalletCredits={false}
                          />
                        {/if}
                        <svelte:component
                          this={bannerComponent}
                          variant={priceVariant}
                          bannerType={BASICPRIME}
                          algoliaProductHit={convertProductDataToUnbxd}
                        />
                      {/if}
                    {:else if userPrimeLevel === SMARTPRIME || expiredJoodMembershipType === SMARTPRIME}
                      {#if !isTacticalSmartPromo && smartPrimePrice > 0}
                        <svelte:component
                          this={priceComponent}
                          {isMegasaleProduct}
                          variant={priceVariant}
                          priceType={SMARTPRIME}
                          algoliaProductHit={convertProductDataToUnbxd}
                          backgoundOverride={SMARTPRIME}
                          {smartPrimePrice}
                        />
                      {:else if tacticalSmartPrimePrice && tacticalSmartPrimePrice > 0}
                        {#if benefitType === 'WALLET'}
                          <svelte:component
                            this={priceComponent}
                            {isMegasaleProduct}
                            variant={priceVariant}
                            priceType={SMARTPRIME}
                            algoliaProductHit={convertProductDataToUnbxd}
                            backgoundOverride={SMARTPRIME}
                            showWalletCredits={false}
                          />
                        {/if}
                        <svelte:component
                          this={bannerComponent}
                          variant={priceVariant}
                          bannerType={SMARTPRIME}
                          algoliaProductHit={convertProductDataToUnbxd}
                        />
                      {/if}
                    {:else}
                      <svelte:component
                        this={priceComponent}
                        {isMegasaleProduct}
                        variant={priceVariant}
                        priceType={NOPRIME}
                        algoliaProductHit={convertProductDataToUnbxd}
                        backgoundOverride={NOPRIME}
                        showWalletCredits={false}
                      />
                      {#if benefitType === 'WALLET'}
                        {#if !isTacticalVipPromo && convertProductDataToUnbxd?.vipPrimePrice > 0}
                          <ProductTileWalletBenefits
                            creditPoints={getJoodDayCredits(VIPPRIME, convertProductDataToUnbxd)}
                            variant={priceVariant}
                            isTacticalFlag={false}
                          />
                        {:else if isTacticalVipPromo && convertProductDataToUnbxd?.vipPrimePrice > 0}
                          <JoodDayBannerWalletBenefits
                            creditPoints={getJoodDayCredits(VIPPRIME, convertProductDataToUnbxd)}
                            variant={priceVariant}
                            algoliaProductHit={convertProductDataToUnbxd}
                          />
                        {/if}
                      {/if}
                      <svelte:component
                        this={bannerComponent}
                        variant={priceVariant}
                        bannerType={VIPPRIME}
                        algoliaProductHit={convertProductDataToUnbxd}
                      />
                    {/if}
                  {/if}
                  {#if remainingQuantityFlag && joodPromoemainingQuantity > 0}
                    <JoodRemainingQty
                      isJoodDayFlag={expiredJoodMembershipType ? expiredJoodMembershipType : userPrimeLevel}
                      joodDayRemainingQuantity={joodPromoemainingQuantity}
                      variant="pdp"
                    />
                  {/if}
                </div>
              {:else if !expiredJoodMembershipType}
                <!-- {#if expiredJoodMembershipType && hasJoodPrices}
                  <svelte:component
                    this={priceComponent}
                    {isMegasaleProduct}
                    variant="qac"
                    priceType={NOPRIME}
                    algoliaProductHit={convertProductDataToUnbxd}
                    backgoundOverride={NOPRIME}
                    showWalletCredits={false}
                  />
                {/if} -->
                {#if !isTacticalVipPromo && convertProductDataToUnbxd?.vipPrimePrice > 0}
                  {#if benefitType === 'WALLET'}
                    <ProductTileWalletBenefits
                      creditPoints={getJoodDayCredits(VIPPRIME, convertProductDataToUnbxd)}
                      variant={priceVariant}
                      isTacticalFlag={false}
                    />
                  {:else}
                    <svelte:component
                      this={priceComponent}
                      {isMegasaleProduct}
                      variant={priceVariant}
                      priceType={VIPPRIME}
                      algoliaProductHit={convertProductDataToUnbxd}
                      backgoundOverride={NOPRIME}
                      showWalletCredits={false}
                    />
                  {/if}
                {:else if isTacticalVipPromo && convertProductDataToUnbxd?.vipPrimePrice > 0}
                  <svelte:component
                    this={bannerComponent}
                    variant={priceVariant}
                    bannerType={VIPPRIME}
                    algoliaProductHit={convertProductDataToUnbxd}
                  />
                {/if}
              {/if}
            {/if}
            <!-- <AtcTasheel entry={cartData?.entry} /> -->
            <AtcGifts entry={cartData?.entry} />
          {/if}
        </div>
      </div>
    </Cell>
  </LayoutGrid>
</section>

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  .add-to-cart-header-section {
    :global {
      .jood-cart-popup {
        .c_joodclock {
          width: 80px;
          @include responsive {
            width: 54px;
          }
        }
        .user-BASICPRIME:not(.expired-card),
        .user-VIPPRIME:not(.expired-card) {
          .c_joodclock {
            width: 130px;
            @include responsive {
              width: 84px;
            }
          }
        }
      }

      .mdc-layout-grid {
        padding: 0;
      }
      .mdc-layout-grid__inner {
        gap: 0;
      }
      .c_icon_new--check {
        color: $icon-only-icon-blue;
      }
    }

    .c_add-to-cart-popup-item-price {
      flex-direction: row;
      justify-content: space-between;
      border: 0;
      align-items: center;
      :global(img) {
        border-radius: 5px;
      }
    }
  }
  .c_joodcart-wrapper {
    flex-direction: column;
    :global(.product-price-new-container) {
      gap: 4px;
    }
  }
  :global(.jood-day-banner-new) {
    position: relative;
  }
</style>
